import { render, staticRenderFns } from "./babyArchives.vue?vue&type=template&id=4a070e05&scoped=true"
import script from "./babyArchives.vue?vue&type=script&lang=js"
export * from "./babyArchives.vue?vue&type=script&lang=js"
import style0 from "./babyArchives.vue?vue&type=style&index=0&id=4a070e05&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a070e05",
  null
  
)

export default component.exports